// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"182":"4e236fc4","205":"c9f313b1","374":"e217db79","508":"4b412225","551":"c2ddb01f","869":"b6dda42b"}[chunkId] + ".chunk.js";
};